//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {mapState,mapMutations} from 'vuex'
  import { walletLogin, ptlogin } from '../service/getdata'
  export default {
    data() {
      return {
        activeIndex: '',
        type:1,
        setInfo:{},
        list: [
          { title: 'Deutsch', key: 'de', image:'static/imgs/lang/de.png' }, //德语
          { title: 'India', key: 'india', image:'static/imgs/lang/india.png' }, //印度
          { title: 'English', key: 'en', image:'static/imgs/lang/en-US.png'},//英语
          { title: 'español', key: 'es', image: 'static/imgs/lang/Spanish.png'}, //西班牙
          { title: 'Français', key: 'fr', image: 'static/imgs/lang/French.png' }, //法语
          { title: 'Italiano', key: 'italy', image:'static/imgs/lang/Italy.png' }, //意大利语
          { title: '日本語', key: 'jp', image:'static/imgs/lang/Japanese.png' }, //日语
          { title: '한국인', key: 'kor', image: 'static/imgs/lang/Korean.png'}, //汉语
          { title: 'Portugal', key: 'pt', image:'static/imgs/lang/pt.png' }, //葡萄牙
          { title: 'Tiếng Việt', key: 'vi', image: 'static/imgs/lang//vi.png'},//越南语
          { title: '繁体中文', key: 'cn', image: 'static/imgs/lang//taiwan.png'},  //简体中文
          { title: '简体中文', key: 'zh', image: 'static/imgs/lang//zh-CN.png'},//繁体中文
          { title: 'Ελληνικά', key: 'gr', image: 'static/imgs/lang//Greek.png'}, //希腊语
          { title: 'ไทย', key: 'th', image: 'static/imgs/lang//Thai.png'}, //泰语
        ]
      };
    },
    created(){
      // this.CONNECT_WALLET()
      this.SETUSERNAME('')
      // this.username = window.sessionStorage.getItem("username") || '';
      console.log(this.username)
      this.activeIndex = sessionStorage.getItem('keyPath') || '1';
      this.getAppName()
    },
     computed:{
            ...mapState(['username', 'address'])
        },
    methods: {
      ...mapMutations(['SETUSERNAME', 'CLEAN_ALL', 'CONNECT_WALLET', 'SETTOKEN']),
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
        sessionStorage.setItem('keyPath', keyPath);
      },
      // handleCommand(command) {
      //   this.$message('click on item ' + command);
      // },
       getAppName(){
                var that = this
            ptlogin().then(function(res){
                var res = res.data;
                this.setInfo =res.data
            
            }.bind(this),function(){
                console.log("error")
            })
        },
      handleCommand(lang){
        console.log(lang)
          window.localStorage.setItem("locale", lang);
          this.$i18n.locale = lang;
          this.lang = lang
          window.localStorage.setItem("lang", lang);
          this.setCookie('lang', lang, 30)
      },
      login(){
            var that = this
            this.$Loading()
            walletLogin({walletaddress: this.address}).then(function(res){
                var res = res.data;
                that.$Loading.close()
                if (res.status=='1') {
                    that.SETTOKEN(res.data.token);
                    window.localStorage.setItem('uid',res.data.uid)
                    // that.$router.push('/pages/home/quotes')
                } else {
                    that.sendMsg(res.message)
                }
                
            }.bind(this),function(){
                that.$Loading.close()
                console.log("error")
            })
        },
      Logout(){
            var that = this;
            this.$vux.confirm.show({
                title: that.$t("提示"),
                content:that.$t("确定退出登录"),
                cancelText:that.$t("取消"),
                confirmText: that.$t("确定"),
                onConfirm:function(){
                    
                    that.CLEAN_ALL()
                      window.localStorage.setItem("lang", that.lang)
                      window.localStorage.setItem("username", that.username)
                      window.localStorage.setItem("password", that.password)
                       that.SETUSERNAME(undefined)
                       console.log(that.username)
                    that.$router.push('/pages/login')
                }
            })
        },
      setCookie(cname, cvalue, exdays) {

          var d = new Date();
      
          d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      
          var expires = "expires=" + d.toUTCString();
      
          console.info(cname + "=" + cvalue + "; " + expires);
      
          document.cookie = cname + "=" + cvalue + "; " + expires;
      
          console.info(document.cookie);
      
      }
    },
    watch:{
            address: {
                handler(curVal, oldVal) {
                  console.log(curVal)
                  console.log(oldVal)
                    if(curVal != oldVal){
                       if(curVal!=''){
                        this.login()
                       }
                    }
                    
                     
                },
                deep: true
            },

        },
  }



// WEBPACK FOOTER //
// ./src/pages/allPages.vue